import { AxiosResponse } from 'axios';
import createAuthRefreshInterceptor from 'axios-auth-refresh';
import store from 'store';

import { getRefreshToken } from 'config/api';

import {
    getEntitlements,
    loginSuccess,
    setRefreshTokenError,
    setSuspensionType,
} from 'store/user/actions';
import { AuthData, SUSPENSION_TYPES } from 'store/user/reducer.types';
import { selectUserAuthData } from 'store/user/selectors';
import { NO_AUTH_DATA_ERROR, isVoluntarySuspension } from 'store/user/utils';

import { request, response } from './interceptors';
import { createInstance } from './utils';

const DefaultInstance = createInstance();

export const setAuthorizationToken = (token?: string) => {
    if (token) {
        DefaultInstance.defaults.headers.common.Authorization = `Bearer ${token}`;
    } else {
        delete DefaultInstance.defaults.headers.common.Authorization;
    }
};

DefaultInstance.interceptors.request.use(request);

DefaultInstance.interceptors.response.use(response);

// Function that will be called  to refresh authorization
const refreshAuthLogic = async (failedRequest: any) => {
    const authData = selectUserAuthData(store.getState());

    if (!authData) {
        return Promise.reject(new Error(NO_AUTH_DATA_ERROR));
    }

    return DefaultInstance.post(
        getRefreshToken(),
        {},
        {
            headers: {
                'nv-tenant-id': 'nagra',
                Authorization: `Bearer ${authData.refresh_token}`,
            },
            // @ts-ignore
            skipAuthRefresh: true,
        },
    )
        .then((tokenRefreshResponse: AxiosResponse<AuthData>) => {
            const authInfo = tokenRefreshResponse?.data;
            setAuthorizationToken(authInfo?.access_token);

            // eslint-disable-next-line no-param-reassign
            failedRequest.response.config.headers.Authorization = `Bearer ${authInfo?.access_token}`;

            store.dispatch(loginSuccess(authInfo));
            store.dispatch(getEntitlements({ autoRetry: true }));

            return Promise.resolve();
        })
        .catch((error: any) => {
            if (isVoluntarySuspension(error)) {
                store.dispatch(setSuspensionType(SUSPENSION_TYPES.VOLUNTARY));
            } else {
                store.dispatch(setRefreshTokenError(error));
            }

            return Promise.reject(new Error('Refresh token request failed'));
        });
};

createAuthRefreshInterceptor(DefaultInstance, refreshAuthLogic, {
    statusCodes: [401],
    pauseInstanceWhileRefreshing: true,
});

export default DefaultInstance;
